import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProveReviewInfo from './ProveReviewInfo';
import ProveEditInfo from './ProveEditInfo';

import WidgetPropTypes from '../types';

export const WIDGET_NAME = 'prove_review';

class ProveReview extends Component {
  constructor() {
    super();

    this.state = {
      displayReviewInfo: true,
      displayEditInfo: false
    };
  }

  reviewInfo = () => {
    this.setState({
      displayEditInfo: false,
      displayReviewInfo: true
    });
  };

  editInfo = () => {
    this.setState({
      displayEditInfo: true,
      displayReviewInfo: false
    });
  };

  render() {
    return (
      <div data-dd-privacy="mask">
        {this.state.displayReviewInfo && (
          <ProveReviewInfo editInfo={this.editInfo} {...this.props} />
        )}
        {this.state.displayEditInfo && (
          <ProveEditInfo reviewInfo={this.reviewInfo} {...this.props} />
        )}
      </div>
    );
  }
}

ProveReview.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired
};

export default ProveReview;
